<script setup>
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

</script>

<template>
    <div class="divide-y">
        <div class="pb-6 space-y-3">
            <div class="space-y-2">
                <h3 class="text-lg font-medium">Page details</h3>
                <p class="text-gray-500 text-sm">The heading and the description of your sign-up page.</p>
            </div>
            <text-field
                label="Title"
                name="portal_login_title"
                type="text"
                v-model="portalContentAndDesignStore.translationSettings.portal_login_title"
            >
            </text-field>

            <text-editor
                name="portal_login_description"
                :text="portalContentAndDesignStore.translationSettings.portal_login_description"
                @input="(newValue) => { portalContentAndDesignStore.translationSettings.portal_login_description = newValue }"
            >
            </text-editor>

            <radio-group-inline
                label="Branding"
                name="program_login_page_branding_type"
                v-model="portalContentAndDesignStore.loginPageSettings.program_login_page_branding_type"
                :options="[
                              { value: 'none', label: 'None'},
                              { value: 'symbol', label: 'Symbol'},
                              { value: 'logo', label: 'Logo'}
                          ]">
              <template #note>
                Select which image to display above the login title.
              </template>
            </radio-group-inline>
        </div>
    </div>
</template>
